<template>
    <div class="sec-cont">
        <Head :title="__('Users')"/>
        <div class="mb-6 flex flex-col md:flex-row gap-3 justify-between items-center ticket-filters">
            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset"></search-input>
            <!--            <div class="filter-add-new flex flex-col gap-3 md:flex-row w-full items-center max-w-md">
                            <select-input v-model="form.role_id" class=" mr-2 w-full">
                                <option :value="null">{{ __('Filter by role') }}</option>
                                <option v-for="(r, ri) in roles" :key="ri" :value="r.id">{{ r.name }}</option>
                            </select-input>
                            <Link class="btn-indigo" :href="route('users.create')">
                                <span>{{ __('Create New') }}</span>
                            </Link>
                        </div>-->
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">{{ __('Name') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Contact Number') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Marital Status') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Experience') }}</th>

                    <th class="pb-4 pt-6 px-6 flex"
                        v-click-outside="()=>{visible.menu_recent = false}"
                        @click="visible.menu_recent = !visible.menu_recent">
                        {{ __('Application Status') }}
                        <icon class="ml-2 w-4 h-4 text-black" name="arrow-down"/>
                    </th>

                    <ul v-if="visible.menu_recent" class="menu-dropdown">
                        <li
                            v-for="status in transformedStatusList"
                            :key="status.label"
                            :class="{ 'highlighted': selectedStatus === status.label }"
                            @click="selectStatus(status.value)">
                            {{ status.label }}
                        </li>
                    </ul>

                    <th class="pb-4 pt-6 px-6">{{ __('Action ') }}</th>
                </tr>
                <tr v-for="user in interviews.data" :key="interviews.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100"
                >
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500">
                            <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo"/>
                            {{ user.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.contact_number }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.marital_status }}
                        </Link>
                    </td>
                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ user.work_experience ? user.work_experience : null }}
                        </Link>
                    </td>

                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4"
                              :class="{ 'text-red-500': user.interview_status_id === 3, 'text-green-600' :user.interview_status_id === 2 }"
                              tabindex="-1"
                        >
                            {{ user.interview_status ? user.interview_status : null }}
                        </Link>
                    </td>


                    <td class="w-px border-t flex items-center px-6 py-4 focus:text-indigo-500">
                        <Link v-if="user.interview_status_id === 1 " class="btn btn-primary"
                              :href="route('staff.edit', { applicant: user.id })"
                        >
                            Add Staff Info
                        </Link>
                        <Link v-if="user.interview_status_id === 2 || interviews.interview_status_id === 3 "
                              class="btn btn-primary" :href="route('interview.edit', { applicant: user.id })"
                        >
                            Edit
                        </Link>
                    </td>
                </tr>
                <tr v-if="interviews.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No users found.</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="interviews.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        SearchInput,
        Head,
        Icon,
        Link,
        SelectInput,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        interviews: Object,
        roles: Array,
        interviewStatusList: {
            type: Object,
            required: true,
        }
    },

    data() {
        console.log(this.interviewStatusList);
        return {
            form: {
                search: this.filters.search,
                selectedStatus: this.filters.interviewStatusList ?? null,
            },
            visible: {
                project_create: false,
                create_workspace: false,
                menu_workspace: false,
                menu_recent: false,
                menu_star: false,
                menu_create: false,
            },
            selectedStatus: '' ,
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('admin.interviewList'), pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    computed:{
        transformedStatusList() {
            // Transform the object into an array format suitable for v-for
            return Object.entries(this.interviewStatusList).map(([value, label]) => ({
                value,
                label
            }));
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        selectStatus(status) {
            this.form.selectedStatus = status
            this.visible.menu_recent = false; // Close the dropdown after selection
        },
    },
}
</script>
